import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";

import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

import Holder from "./components/holder";
import Header from "./components/header";
import Button from "./components/button";
import Footer from "./components/footer";
import Display from "./components/display";
import NumberPicker from "./components/number_picker";
import CasaItemPacote from "./components/casa_pacote";
// import ComidaItem from "./components/comida";
// import ExtraItem from "./components/extra";

import Api from "../libs/api";
import Helper from "../libs/helper";
import MonthPicker from "./components/month_picker";
import PacoteItem from "./components/pacote";

const parse = require("html-react-parser");

const Wrapper = styled.div`
  background: #f9f9f9;
`;

const BottomHolder = styled.div`
  left: 0;
  bottom: 0;
  right: 0;
`;

const Bolder = styled.span`
  font-weight: bold;
`;

const Linked = styled.a`
  text-decoration: underline;
  cursor: pointer;
`;

// const Intention = styled.div`
//   width: 100%;
//   height: auto;
// `;

const Adults = styled.div`
  width: 100%;
  height: auto;
`;

// const IntentionOption = styled.button`
//   width: 50%;
//   float: left;
//   height: 84px;
//   border: 1px solid #e96159;
//   background: none;
//   color: #e96159;
//   padding: 0px 16px;
//   cursor: pointer;
//   border-top: none;
//   font-weight: bold;
//   &:hover {
//     background: #e96159;
//     color: #ffffff;
//   }
// `;

// const NotFoodTitle = styled.div`
//   font-family: "Basteleur";
//   font-style: normal;
//   font-weight: 400;
//   font-size: 24px;
//   line-height: 125%;
//   color: #e96159;
//   margin-top: 24px;
// `;

// const NotFoodDescription = styled.div`
//   font-family: "Inter";
//   font-style: normal;
//   font-weight: normal;
//   font-size: 16px;
//   line-height: 150%;
//   color: #737373;
//   margin-top: 16px;
//   margin-bottom: 16px;
// `;

// const Clear = styled.div`
//   clear: both;
// `;

// const RestrictionsField = styled.textarea`
//   background: #ffffff;
//   border: 1px solid #e96159;
//   border-radius: 8px;
//   width: 100%;
//   height: 200px;
//   margin-top: 16px;
//   margin-bottom: 16px;
//   padding: 16px;
//   font-family: "Inter";
//   font-style: normal;
//   font-weight: 400;
//   font-size: 16px;
//   line-height: 125%;
//   color: #737373;
// `;

const CustomInput = styled.input`
  background: #ffffff;
  border: 1px solid #bfbfbf;
  border-radius: 8px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 125%;
  color: #737373;
  width: 100%;
  padding: 16px;
  margin-top: 16px;
`;

const CustomInputLast = styled.input`
  background: #ffffff;
  border: 1px solid #bfbfbf;
  border-radius: 8px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 125%;
  color: #737373;
  width: 100%;
  padding: 16px;
  margin-top: 16px;
  margin-bottom: 16px;
`;

const InputError = styled.div`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 125%;
  color: #e96159;
`;

const NoCasasError = styled.div`
  font-family: "Basteleur";
  font-style: normal;
  font-weight: 400;
  font-size: 32px;
  line-height: 125%;
  color: #e96159;
  margin-top: 32px;
  margin-bottom: 32px;
`;

const Resume = styled.div`
  font-family: "Inter";
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 125%;
  color: #737373;
  margin-top: 32px;
  margin-bottom: 32px;
`;

const Price = styled.span`
  display: block;
  float: right;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: #ffffff;
  background: #e96159;
  padding: 4px 20px;
  border-radius: 19px;
  margin-top: -5px;
`;

const DoNotWant = styled.div`
  padding: 16px;
  font-weight: 700;
  font-size: 16px;
  line-height: 125%;
  color: #737373;
`;

const DoNotWantLink = styled.a`
  font-weight: 400;
  font-size: 16px;
  line-height: 125%;
  text-decoration-line: underline;
  color: #e96159;
  display: block;
`;

export default function Packages() {
  let navigate = useNavigate();
  let api = Api();
  let helper = Helper();

  const [step, setStep] = useState(0);

  const [payment, setPayment] = useState();
  const [pacotes, setPacotes] = useState({
    pacotes: [],
  });
  const [casas, setCasas] = useState({
    casas: [],
  });

  const [adults, setAdults] = useState(0);
  const [children, setChildren] = useState(0);
  const [animals, setAnimals] = useState(0);
  const [casa, setCasa] = useState(null);
  const [pacote, setPacote] = useState(null);

  const [name, setName] = useState(null);
  const [email, setEmail] = useState(null);
  const [_document, setDocument] = useState(null);
  const [phone, setPhone] = useState(null);
  const [zipcode, setZipcode] = useState(null);
  const [address, setAddress] = useState(null);
  const [number, setNumber] = useState(null);
  const [complement, setComplement] = useState(null);
  const [neighborhood, setNeighborhood] = useState(null);
  const [city, setCity] = useState(null);
  const [state, setState] = useState(null);

  const [nameError, setNameError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [_documentError, setDocumentError] = useState(false);
  const [phoneError, setPhoneError] = useState(false);
  const [zipcodeError, setZipcodeError] = useState(false);
  const [addressError, setAddressError] = useState(false);
  const [numberError, setNumberError] = useState(false);
  const [neighborhoodError, setNeighborhoodError] = useState(false);
  const [cityError, setCityError] = useState(false);
  const [stateError, setStateError] = useState(false);
  //   const [byPass, setByPass] = useState(false);

  useEffect(() => {
    if (zipcode && zipcode.length === 8) {
      api.getZipcode(zipcode).then((data) => {
        setZipcodeError(false);
        setAddress(data.logradouro);
        setAddressError(false);
        setNeighborhood(data.bairro);
        setNeighborhoodError(false);
        setCity(data.localidade);
        setCityError(false);
        setState(data.uf);
        setStateError(false);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [zipcode]);

  const [hasScroll, setHasScroll] = useState(true);
  const [height, setHeight] = useState(window.innerHeight);

  const { id } = useParams();

  useEffect(() => {
    if (id) {
      getPacote(id, 1, 0);
      setStep(1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  function handleWindowSizeChange() {
    setHasScroll(true);
    setHeight(window.innerHeight);
  }

  const monthToName = (month) => {
    let months = [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro",
    ];
    return months[month];
  };

  const formatDate = (date) => {
    return `${date.getDate()} de ${monthToName(date.getMonth())}`;
  };

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    window.addEventListener("load", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
      window.addEventListener("load", handleWindowSizeChange);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const saveReserva = async () => {
    let response = await api.reservarPacote(
      name,
      email,
      _document,
      phone,
      zipcode,
      address,
      number,
      complement,
      neighborhood,
      city,
      state,
      adults,
      children,
      animals,
      casa,
      pacote,
      getAllTotal()
    );
    setPayment(response);
  };

  const getCasas = async () => {
    let response = await api.getCasasPacotesAvailable(
      pacote,
      adults + children
    );

    let groups = [];
    let casas = [];

    if (pacote.g1) {
      groups.push("G1");
    }
    if (pacote.g2) {
      groups.push("G2");
    }
    if (pacote.g3) {
      groups.push("G3");
    }
    if (pacote.g4) {
      groups.push("G4");
    }
    if (pacote.g5) {
      groups.push("G5");
    }
    if (pacote.g6) {
      groups.push("G6");
    }
    if (pacote.g7) {
      groups.push("G7");
    }
    if (pacote.g8) {
      groups.push("G8");
    }

    for (let index = 0; index < response.casas.length; index++) {
      const casa = response.casas[index];
      if (groups.includes(casa.group)) {
        casas.push(casa);
      }
    }

    response["casas"] = casas;
    setCasas(response);
  };

  const getPacote = async (id, _adults, _children) => {
    let response = await api.getPacote(id, _adults, _children);
    setPacote(response);
  };

  const getPacotes = async (date) => {
    let response = await api.getPacotes(date);
    setPacotes(response);
  };

  useEffect(() => {
    const date = new Date().toISOString();
    getPacotes(date);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (step === 3) {
      setStep(4);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [casa]);

  useEffect(() => {
    window.scrollTo(0, 0);

    if (step === 0) {
      setHasScroll(false);
      setHeight(window.innerHeight);
    }
    if (step > 0) {
      setHasScroll(true);
      setHeight(window.innerHeight);
    }

    if (step === 5) {
      // TODO FINISH HERE
      saveReserva();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step]);

  const getAllTotal = () => {
    let total = 0;

    if (casa) {
      if (casa.group === "G1") {
        total = total + pacote.g1;
      }
      if (casa.group === "G2") {
        total = total + pacote.g2;
      }
      if (casa.group === "G3") {
        total = total + pacote.g3;
      }
      if (casa.group === "G4") {
        total = total + pacote.g4;
      }
      if (casa.group === "G5") {
        total = total + pacote.g5;
      }
      if (casa.group === "G6") {
        total = total + pacote.g6;
      }
      if (casa.group === "G7") {
        total = total + pacote.g7;
      }
      if (casa.group === "G8") {
        total = total + pacote.g8;
      }
    }

    const _adults = adults * pacote.price;
    const _children = children * pacote.price * 0.6;

    return total + _adults + _children;
  };

  return (
    <Wrapper style={{ height: height }}>
      <Header inverted={false} />
      {step === 0 && pacotes.data && (
        <>
          <Display
            text={`Experiências em ${monthToName(pacotes.data.month)} ${
              pacotes.data.year
            }`}
          />
        </>
      )}
      {step === 1 && pacote && (
        <Display text={"Quem vem?"} extra={`${pacote.name}`}>
          Vem sozinha ou vem em grupo?
        </Display>
      )}
      {step === 2 && pacote && (
        <Display text={"Onde você quer ficar?"} extra={`${pacote.name}`}>
          Casas para <Bolder>{adults + children} pessoa(s)</Bolder>
          <br />
          <Linked
            onClick={() => {
              setStep(1);
            }}
          >
            Alterar número de pessoas.
          </Linked>
        </Display>
      )}
      {step === 4 && (
        <Display
          text={"Vamos nos conhecer?"}
          extra={`${pacote.name}`}
          total={helper.floatToMoney(getAllTotal())}
        >
          Precisamos de suas informações para continuar.
        </Display>
      )}
      {step === 5 && (
        <Display text={"Confira a sua reserva"} extra={`${pacote.name}`}>
          O que você está comprando:
        </Display>
      )}

      <Holder color="#f9f9f9">
        {step === 0 && pacotes.data && (
          <>
            <MonthPicker
              year={pacotes.data.year}
              month={pacotes.data.month}
              day={pacotes.data.day}
              callback={(date) => {
                getPacotes(date.toISOString());
              }}
            />
            {pacotes.pacotes.map((_pacote) => {
              return (
                <PacoteItem
                  key={_pacote.id}
                  pacote={_pacote}
                  callback={(pacote) => {
                    navigate(`/experiencia/${pacote.id}`);
                  }}
                />
              );
            })}
            {pacotes.pacotes.length === 0 && (
              <>
                <NoCasasError>
                  Ainda não há experiências neste mês, aguarde!
                </NoCasasError>
                <img
                  style={{ width: "100%", marginBottom: 16 }}
                  src="/images/no-casa.png"
                  alt="Ainda não há experiências neste mês, aguarde!"
                />
              </>
            )}
          </>
        )}
        {step === 1 && (
          <Adults>
            <NumberPicker title={"Adultos"} callback={setAdults} />
            <NumberPicker
              title={"Crianças (até 12 anos)"}
              callback={setChildren}
            />
            <NumberPicker title={"Animais"} callback={setAnimals} />
            <br />
          </Adults>
        )}
        {step === 2 && (
          <>
            {casas.casas.map((casa) => {
              return (
                <CasaItemPacote
                  key={casa.id}
                  casa={casa}
                  pacote={pacote}
                  adults={adults}
                  children={children}
                  callback={(casa) => {
                    setCasa(casa);
                    setStep(3);
                  }}
                />
              );
            })}
            {casas.casas.length === 0 && (
              <>
                <NoCasasError>
                  Não há casas disponíveis nessa data :(
                </NoCasasError>
                <img
                  style={{ width: "100%", marginBottom: 16 }}
                  src="/images/no-casa.png"
                  alt="Não há casas disponíveis nessa data"
                />
              </>
            )}
          </>
        )}

        {step === 4 && (
          <>
            <CustomInput
              placeholder="Nome"
              onChange={(event) => setName(event.target.value)}
            />
            {nameError && (
              <InputError>Preencha corretamente seu nome</InputError>
            )}
            <CustomInput
              placeholder="Email"
              onChange={(event) => setEmail(event.target.value)}
            />
            {emailError && (
              <InputError>Preencha corretamente seu email</InputError>
            )}
            <CustomInput
              placeholder="CPF"
              maxLength="11"
              onChange={(event) => setDocument(event.target.value)}
            />
            {_documentError && (
              <InputError>Preencha corretamente seu CPF</InputError>
            )}
            <CustomInput
              placeholder="Whatsapp"
              maxLength="11"
              onChange={(event) => setPhone(event.target.value)}
            />
            {phoneError && (
              <InputError>Preencha corretamente seu telefone</InputError>
            )}
            <CustomInput
              placeholder="CEP"
              maxLength="8"
              onChange={(event) => setZipcode(event.target.value)}
            />
            {zipcodeError && (
              <InputError>Preencha corretamente seu CEP</InputError>
            )}
            <CustomInput
              placeholder="Endereço"
              defaultValue={address}
              onChange={(event) => setAddress(event.target.value)}
            />
            {addressError && (
              <InputError>Preencha corretamente seu endereço</InputError>
            )}
            <CustomInput
              placeholder="Número"
              onChange={(event) => setNumber(event.target.value)}
            />
            {numberError && (
              <InputError>Preencha corretamente seu número</InputError>
            )}
            <CustomInput
              placeholder="Complemento"
              onChange={(event) => setComplement(event.target.value)}
            />
            <CustomInput
              placeholder="Bairro"
              defaultValue={neighborhood}
              onChange={(event) => setNeighborhood(event.target.value)}
            />
            {neighborhoodError && (
              <InputError>Preencha corretamente seu bairro</InputError>
            )}
            <CustomInput
              placeholder="Cidade"
              defaultValue={city}
              onChange={(event) => setCity(event.target.value)}
            />
            {cityError && (
              <InputError>Preencha corretamente sua cidade</InputError>
            )}
            <CustomInputLast
              placeholder="Estado"
              defaultValue={state}
              onChange={(event) => setState(event.target.value)}
            />
            {stateError && (
              <>
                <InputError>Preencha corretamente seu estado</InputError>
                <br />
              </>
            )}
          </>
        )}

        {step === 5 && (
          <Resume>
            <Bolder>Data:</Bolder>
            <br />
            {formatDate(helper.stringToDate(pacote.start)) ===
            formatDate(helper.stringToDate(pacote.end)) ? (
              <>{formatDate(helper.stringToDate(pacote.start))}</>
            ) : (
              <>
                {formatDate(helper.stringToDate(pacote.start))} a{" "}
                {formatDate(helper.stringToDate(pacote.end))}
              </>
            )}
            <br />
            <br />
            <Bolder>{pacote.name}</Bolder>
            <br />
            {casa && casa.name && (
              <>
                {casa.name}
                <br />
              </>
            )}
            {adults === 1 ? "1 adulto" : `${adults} adultos`}
            <br />
            {children === 0
              ? "Nenhuma criança"
              : children === 1
              ? `1 criança`
              : `${children} crianças`}
            <br />
            {animals === 0
              ? "Nenhum animal"
              : animals === 1
              ? `1 animal`
              : `${animals} animais`}
            <br />
            <br />
            <Bolder>O que está incluso</Bolder>:
            <br />
            {pacote.description && parse(pacote.description)}
            <br />
            <br />
            <br />
            <Bolder>Total:</Bolder>
            <Price>{helper.floatToMoney(getAllTotal())}</Price>
            <br />
          </Resume>
        )}
      </Holder>
      <BottomHolder
        style={{
          position: step === 0 ? "relative" : hasScroll ? "relative" : "fixed",
        }}
      >
        {step === 0 && (
          <Holder color="#f9f9f9">
            <DoNotWant>
              Não quero comprar a experiência
              <DoNotWantLink
                href="https://airbnb.com.br/p/fazendacosmica"
                target="_blank"
              >
                Ver somente acomodações.
              </DoNotWantLink>
            </DoNotWant>
          </Holder>
        )}
        {step === 1 && (
          <>
            <Button
              inverted={true}
              callback={() => {
                if (adults > 0) {
                  if (
                    pacote.g1 ||
                    pacote.g2 ||
                    pacote.g3 ||
                    pacote.g4 ||
                    pacote.g5 ||
                    pacote.g6 ||
                    pacote.g7 ||
                    pacote.g8
                  ) {
                    getCasas();
                    setStep(2);
                  } else {
                    setStep(4);
                  }
                }
              }}
            >
              CONTINUAR
            </Button>
            <div style={{ borderTop: "1px solid #e96159" }}>
              <Holder>
                <p style={{ padding: "16px 0px", color: "#737373" }}>
                  <strong style={{ fontWeight: 700 }}>Mudei de ideia</strong>
                  <br />
                  <a style={{ color: "#E96159" }} href={"/"}>
                    Escolher outra experiência ou outra data.
                  </a>
                </p>
              </Holder>
            </div>
          </>
        )}
        {step === 2 && adults > 0 && casas && casas.casas.length === 0 && (
          <Button
            inverted={true}
            callback={() => {
              navigate("/");
              setStep(0);
            }}
          >
            BUSCAR OUTRA DATA
          </Button>
        )}
        {step === 3 && (
          <Button
            inverted={true}
            callback={() => {
              setStep(4);
            }}
          >
            JÁ TENHO HOSPEDAGEM
          </Button>
        )}
        {step === 4 && (
          <Button
            inverted={true}
            callback={() => {
              if (
                name &&
                email &&
                _document &&
                phone &&
                zipcode &&
                address &&
                number &&
                neighborhood &&
                city &&
                state
              ) {
                setStep(5);
              } else {
                if (!name) {
                  setNameError(true);
                } else {
                  setNameError(false);
                }
                if (!helper.validateEmail(email)) {
                  setEmailError(true);
                } else {
                  setEmailError(false);
                }
                if (!helper.validarCPF(_document)) {
                  setDocumentError(true);
                } else {
                  setDocumentError(false);
                }
                if (!phone) {
                  setPhoneError(true);
                } else {
                  setPhoneError(false);
                }
                if (!zipcode) {
                  setZipcodeError(true);
                } else {
                  setZipcodeError(false);
                }
                if (!address) {
                  setAddressError(true);
                } else {
                  setAddressError(false);
                }
                if (!number) {
                  setNumberError(true);
                } else {
                  setNumberError(false);
                }
                if (!neighborhood) {
                  setNeighborhoodError(true);
                } else {
                  setNeighborhoodError(false);
                }
                if (!city) {
                  setCityError(true);
                } else {
                  setCityError(false);
                }
                if (!state) {
                  setStateError(true);
                } else {
                  setStateError(false);
                }
              }
            }}
          >
            CONTINUAR
          </Button>
        )}
        {step === 5 && (
          <>
            <Button
              inverted={true}
              callback={() => {
                //   saveReserva();
                if (payment) {
                  window.open(payment.payment_link, "_blank");
                  navigate("/reservar/end");
                }
              }}
            >
              PAGAR
            </Button>
            <div style={{ borderTop: "1px solid #e96159" }}>
              <Holder>
                <p style={{ padding: "16px 0px", color: "#737373" }}>
                  <strong style={{ fontWeight: 700 }}>Mudou de ideia?</strong>
                  <br />
                  <a style={{ color: "#E96159" }} href={"/"}>
                    Recomeçar reserva
                  </a>
                </p>
              </Holder>
            </div>
          </>
        )}
        <Footer inverted={false} />
      </BottomHolder>
    </Wrapper>
  );
}
